export default __webpack_public_path__ + "static/food_meals-d8850747f0677a1fbbe212d024cbe4c1.png";